import { Component, Input, OnDestroy, OnInit, inject } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { MarketingFacade } from '../../../facades/marketing.facade';
import { IRfqBaseInfo, IRfqCartItem } from '../../../models/rfq.models';
import { takeUntil } from 'rxjs/operators';
import { ICountry } from '../../../models/common.models';

@Component({
  selector: 'app-my-request-details',
  templateUrl: './my-request-details.component.html',
  styleUrls: ['./my-request-details.component.scss'],
  standalone: false,
})
export class MyRequestDetailsComponent implements OnInit, OnDestroy {
  private marketingFacade: MarketingFacade = inject(MarketingFacade);

  requestItems!: IRfqCartItem[];
  itemsInQueueToCart!: Array<string>;
  itemsInQueueToCartSubscription!: Subscription;
  taxNumber!: string;

  private unsubscribe$: Subject<void> = new Subject<void>();

  @Input() request!: IRfqBaseInfo;
  @Input() isOpen!: boolean;

  ngOnInit(): void {
    this.itemsInQueueToCartSubscription = this.selectItemsInQueueToCart();
    this.requestItems = this._modifyOrderCart(this.request);
    this.taxNumber = this.request.attributes.taxNumber;
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  selectItemsInQueueToCart(): Subscription {
    return this.marketingFacade.selectItemsInQueueToCart().pipe(
      takeUntil(this.unsubscribe$),
    ).subscribe(state => {
      this.itemsInQueueToCart = state;
    });
  }

  addProductToCart(product: string, productName: string): void {
    this.marketingFacade.addProductToCart({sku: product, name: productName}, true);
  }

  renderEmptyAddressField(field: string | ICountry | undefined): string {
    const value: string = typeof field === 'string' ? field : field?.name ?? '';
    return value === 'empty' ? '' : value;
  }

  isAddressFieldEmpty(field: string | ICountry | undefined): boolean {
    const value: string = typeof field === 'string' ? field : field?.name ?? '';
    return value === 'empty' || value === '' || !value;
  }

  isItemInProgress(sku: string): boolean {
    return this.itemsInQueueToCart.includes(sku);
  }

  /**
   * modify order cart items to array of items if it is not an array (when single item is in cart)
   * @param {IRfqBaseInfo} order
   * @returns {IRfqCartItem[]}
   * @private
   */
  private _modifyOrderCart(order: IRfqBaseInfo): IRfqCartItem[] {
    const orderCart: IRfqCartItem[] | Record<string, IRfqCartItem> = order.attributes.shownVersion.cart.items;
    if (!Array.isArray(orderCart)) {
      return Object.values(orderCart);
    }
    return orderCart;
  }
}
